import { createRouter, createWebHistory } from 'vue-router'
import Hello from '@/components/Hello'
import Registration from '@/components/Registration'
import Login from '@/components/Login'
import Protected from '@/components/Protected'
import ForgotPassword from '@/components/ForgotPassword'
import PasswordUpdate from '@/components/PasswordUpdate'
import RegistrationConfirm from '@/components/RegistrationConfirm'
import Hillwood from '@/components/Hillwood'
import { sessionExists } from '@/utils/session'
import { getCookie } from '@/utils/cookie'
import api from './components/backend-api'
import { sessionStart, sessionSet } from '@/utils/session'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: Hello, meta: { title: 'Direct Booking Site for Hosts' } },
        { path: '/registration', component: Registration },
        { path: '/login', component: Login, meta: { loginPage: true } },
        { path: '/forgot-password', component: ForgotPassword },
        { path: '/password-update/:code', component: PasswordUpdate },
        { path: '/protected', component: Protected, meta: { requiresAuth: true } },
        { path: '/registration-confirm/:code', component: RegistrationConfirm },
        { path: '/hillwood', component: Hillwood, meta: { title: 'Stylish Newly Remodeled Home with Putting Green | Lewisville, TX' } },
        { path: '/property/:slug', component: Hillwood, meta: { title: 'Stylish Newly Remodeled Home with Putting Green | Lewisville, TX' } },
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ]
});

const DEFAULT_TITLE = 'Direct Booking Site for Hosts'
router.afterEach((to) => {
    document.title = to.meta.title || DEFAULT_TITLE
})

router.beforeEach(async (to, from) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isLoginPage = to.matched.some(record => record.meta.loginPage);
    const isAuthenticated = sessionExists();
    const token = getCookie('token');

    if ((isLoginPage || requiresAuth) && !isAuthenticated && token != null) {
        try {
            const response = await api.checkTokenExist(token);
            const tokenExist = response.data;
            if (tokenExist) {
                sessionStart();
                sessionSet('token', token);
                return '/protected';
            }
        } catch (error) {
            console.log(error);
        }
    } else if (requiresAuth && !isAuthenticated) {
        return '/login';
    } else if (isLoginPage && isAuthenticated) {
        return '/protected';
    }
});

export default router;